import React from 'react';
import { MapPinIcon } from 'lucide-react';
type Buyer = {
  city: string;
  region: string;
  flag: string;
  buyers: string;
};
const usa: Buyer[] = [{
  city: 'Houston',
  region: 'Texas',
  flag: '🇺🇸',
  buyers: '340+'
}, {
  city: 'Florida',
  region: 'Miami y Orlando',
  flag: '🇺🇸',
  buyers: '285+'
}, {
  city: 'Texas',
  region: 'Dallas y Austin',
  flag: '🇺🇸',
  buyers: '260+'
}, {
  city: 'California',
  region: 'Los Ángeles',
  flag: '🇺🇸',
  buyers: '210+'
}];
const mexico: Buyer[] = [{
  city: 'Ciudad de México',
  region: 'CDMX y Edomex',
  flag: '🇲🇽',
  buyers: '410+'
}, {
  city: 'Guadalajara',
  region: 'Jalisco',
  flag: '🇲🇽',
  buyers: '190+'
}, {
  city: 'México',
  region: 'Resto del país',
  flag: '🇲🇽',
  buyers: '520+'
}];
function BuyerRow({
  buyer
}: {
  buyer: Buyer;
}) {
  return <li className="flex items-center gap-4 py-4" data-id="element-35" data-mp="1zt5xeaam08ro">
      <span className="text-xl leading-none" aria-hidden="true" data-id="element-36" data-mp="1zso1jeruzwka">
        {buyer.flag}
      </span>
      <div className="min-w-0 flex-1" data-id="element-37" data-mp="1uv4bzippnxd1">
        <p className="font-display text-base uppercase leading-tight text-concrete-50 sm:text-lg" data-id="element-38" data-mp="34adkfw4m02gs">
          {buyer.city}
        </p>
        <p className="truncate text-sm text-concrete-400" data-id="element-39" data-mp="39a9n9s1klnur">{buyer.region}</p>
      </div>
      <p className="shrink-0 text-right" data-id="element-40" data-mp="2va7csqvldwpj">
        <span className="font-display text-lg text-safety sm:text-xl" data-id="element-41" data-mp="2vba42zwtu15z">
          {buyer.buyers}
        </span>
        <span className="block text-[11px] uppercase tracking-wide text-concrete-400" data-id="element-42" data-mp="30ad7kfx5rzbu">
          constructores
        </span>
      </p>
    </li>;
}
export function BuyersLocations() {
  return <section className="bg-concrete-900 py-14 sm:py-24" aria-labelledby="compras" data-id="element-43" data-mp="3s1sukb2mno2l">
      <div className="mx-auto max-w-5xl px-5 sm:px-8" data-id="element-44" data-mp="3e81gqqhv5i12">
        <p className="flex items-center gap-2 text-xs font-bold uppercase tracking-[0.2em] text-safety sm:text-sm" data-id="element-45" data-mp="3j6l3uu870zv0">
          <MapPinIcon className="h-4 w-4" aria-hidden="true" data-id="element-46" data-mp="aqjinarw7pdu" />
          De dónde nos compran
        </p>
        <h2 id="compras" className="mt-3 font-display text-3xl uppercase leading-[0.95] text-concrete-50 sm:text-5xl" data-id="element-47" data-mp="fj2xeb2bgqk8">
          Paisanos y maistros{' '}
          <span className="text-safety" data-id="element-48" data-mp="kex5yv8dnfyu">a los dos lados del río</span>
        </h2>
        <p className="mt-4 max-w-2xl text-base leading-relaxed text-concrete-400 sm:text-lg" data-id="element-49" data-mp="ffkn0lkmmt1j">
          El Megapack ya está en la troca y en el celular de constructores que
          chambean en Estados Unidos y en México.
        </p>

        <div className="mt-10 grid gap-8 md:grid-cols-2 md:gap-12" data-id="element-50" data-mp="6g79nhtdtkbj">
          <div data-id="element-51" data-mp="1o5vfqcnljiv">
            <h3 className="border-b-2 border-safety pb-2 font-display text-lg uppercase text-concrete-50" data-id="element-52" data-mp="1nnx8o6fkv8b">
              🇺🇸 Estados Unidos
            </h3>
            <ul className="divide-y divide-concrete-700" data-id="element-53" data-mp="3nvxdnuyd9om2">
              {usa.map(b => <BuyerRow key={b.city} buyer={b} data-id="element-54" data-mp="3iwt3b0zphku5" />)}
            </ul>
          </div>
          <div data-id="element-55" data-mp="3iyngtu8neao7">
            <h3 className="border-b-2 border-safety pb-2 font-display text-lg uppercase text-concrete-50" data-id="element-56" data-mp="3evhc4r16orju">
              🇲🇽 México
            </h3>
            <ul className="divide-y divide-concrete-700" data-id="element-57" data-mp="1ucnbtjxv4h56">
              {mexico.map(b => <BuyerRow key={b.city} buyer={b} data-id="element-58" data-mp="1yd768fr1x6nm" />)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}